import axios from 'axios'
import config from '../config.js'
var URI = require('urijs')

// http ou https
var protocole = 'http'
if (config.secure) {
  protocole = 'https'
}

var axiosConfig = {
  baseURL: protocole + '://' + config.server_domain,
  headers: { 'Token': null }
}

function makeUri(method, params) {
  return URI('') // laisser ''
    .filename(method)
    .search(params)
    .toString()
}

// module
export default {

  setToken: function (token) {
    axiosConfig.headers['Authorization'] = 'Bearer ' + token
  },

  resetToken: function () {
    axiosConfig.headers['Authorization'] = null
  },

  request: function (method, uri, data, directData = false) {
    console.log('[API REQ]', uri)
    return new Promise(function (resolve, reject) {
      var axiosPromise = null
      if (method == 'post') {
        axiosPromise = axios.post(uri, data, axiosConfig)
      } else if (method == 'put') {
        axiosPromise = axios.put(uri, data, axiosConfig)
      } else if (method == 'patch') {
        axiosPromise = axios.patch(uri, data, axiosConfig)
      } else if (method == 'delete') {
        axiosPromise = axios.delete(uri, axiosConfig)
      } else {
        axiosPromise = axios.get(uri, axiosConfig)
      }
      //
      axiosPromise.then(res => {
        if (!res.data) {
          reject(new Error('no res.data'))
        } else {
          // log
          console.log('[API RES]', res.data)
          //
          if (res.data.status == 'success') {

            if (directData) {
              resolve(res.data.data)
            } else {
              resolve(res.data)
            }

          } else {
            reject(new Error(res.data.message))

          }
        }
      }).catch((err) => {
        reject(err)
      })
    })
  },

  post: function (uri, data) {
    return this.request('post', uri, data)
  },

  put: function (uri, data) {
    return this.request('put', uri, data)
  },

  patch: function (uri, data) {
    return this.request('patch', uri, data)
  },

  delete: function (uri) {
    return this.request('delete', uri)
  },

  get: function (uri, params) {
    if (params) {
      // converstion string et ajout URI
      uri = makeUri(uri, params)
    }
    return this.request('get', uri)
  },

  // version pour upload de fichier avec FormData
  postForm: function (uri, formData) {
    return new Promise(function (resolve, reject) {
      axios.post(uri, formData, axiosConfig)
        .then((res) => {
          if (!res.data) {
            reject(new Error('no res.data'))
          } else if (res.data.status == 'success') {
            console.log(res.data)
            resolve(res.data)
          } else if (!res.data.message) {
            reject(new Error('no res.data.message'))
          } else {
            reject(new Error(res.data.message))
          }
        })
        .catch((err) => {
          reject(err)
        })
    })
  },

  //
  patchForm: function (uri, formData) {
    return new Promise(function (resolve, reject) {
      axios.patch(uri, formData, axiosConfig)
        .then((res) => {
          if (!res.data) {
            reject(new Error('no res.data'))
          } else if (res.data.status == 'success') {
            console.log(res.data)
            resolve(res.data)
          } else if (!res.data.message) {
            reject(new Error('no res.data.message'))
          } else {

            reject(new Error(res.data.message))
          }
        })
        .catch((err) => {

          reject(err)
        })
    })
  },

  // telechargement de fichier
  download: function (upid, filename) {
    var url = '/files/' + upid
    var config = Object.assign({ responseType: 'blob' }, axiosConfig)
    axios.get(url, config)
      .then(function (response) {
        const url = window.URL.createObjectURL(new Blob([response.data], { type: response.headers['content-type'] }))
        const link = document.createElement('a')
        link.href = url

        console.log(response)

        link.setAttribute('download', filename)
        document.body.appendChild(link)
        link.click()
      })
  }

}
